import * as deliveryHoursActions from '../actions/deliveryHours'
import { daysOfTheWeek } from '../helpers/week'


const getDefaultEditDeliveryHours = () => {
  let results = {}
  daysOfTheWeek.forEach(dayName => {
    results[dayName] = { poolTimes: [{ startTime: '', endTime: '' }], closed: false }
  })
  return results
}

const areDaysDefined = (data) => {
  let areDefined = true
  daysOfTheWeek.forEach(dayName => {
    if (data[dayName] === null) {
      areDefined = false
      return
    }    
  })
  return areDefined
}

const initialState = {
  poolId: undefined,
  data: undefined,
  editDeliveryHours: getDefaultEditDeliveryHours(),
  isLoading: false,
  editMode: false
}

const deliveryHours = (state = initialState, action) => {
  switch (action.type) {

  case deliveryHoursActions.LOAD_DELIVERYHOURS_REQUESTED:
    return {
      ...state,
      poolId: action.poolId,
      isLoading: true
    }

  case deliveryHoursActions.LOAD_DELIVERYHOURS_LOADED:
    return {
      ...state,
      data: action.data,
      saveError: undefined,
      isLoading: false
    }

  case deliveryHoursActions.LOAD_DELIVERYHOURS_ERROR:
    return {
      ...state,
      error: action.error,
      saveError: undefined,
      isLoading: false
    }

  case deliveryHoursActions.SAVE_DELIVERYHOURS_REQUESTED:
    return {
      ...state,
      poolId: action.poolId,
      data: action.deliveryHours,
      isSaving: true
    }

  case deliveryHoursActions.SAVE_DELIVERYHOURS_LOADED:
    return {
      ...state,
      isSaving: false,
      editMode: false
    }

  case deliveryHoursActions.SAVE_DELIVERYHOURS_ERROR:
    return {
      ...state,
      saveError: action.error,
      isSaving: false,
      editMode: false
    }

  case deliveryHoursActions.DELIVERYHOURS_GOTO_EDIT_MODE:
    return {
      ...state,
      saveError: undefined,
      editMode: action.editMode,
      editDeliveryHours: areDaysDefined(state.data) ? state.data  : getDefaultEditDeliveryHours()
    }

  case deliveryHoursActions.DELIVERYHOURS_UPDATE_EDIT:
    return {
      ...state,
      saveError: undefined,
      editDeliveryHours: action.editDeliveryHours
    }

  default:
    return state
  }
}

export default deliveryHours


// WEBPACK FOOTER //
// ./src/reducers/deliveryHours.js